import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

const styles = theme => ({
  root: {
    height: '100%',
    color: theme.palette.white,
    backgroundColor: theme.palette.tertiary.toast,
  },
  wrapper: {
    ...theme.components.toast,
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  open: {
    opacity: 1,
  },
  content: {
    display: 'flex',
    borderRadius: 5,
    alignItems: 'center',
    backgroundColor: theme.palette.white,
  },
  text: {
    marginLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
})

const ButtonContainer = styled.div`
  display: flex;
  width: 370px;
  justify-content: space-between;
`

const ActionButtonToast = ({
  classes, data, open 
}) => {
  return (
    <div className={classes.root}>
      <section className={classNames(classes.wrapper, open && classes.open)}>
        <Typography className={classes.text}>{data.label}</Typography>
        {data.hasTwoActions ? 
          <ButtonContainer>
            <div className={classes.content}>
              <SubmitButton
                size="medium"
                color="primary"
                variant="secondary"
                onClick={data.secondOnActionClick}>
                {data.secondActionLabel}
              </SubmitButton>
            </div>
            <div className={classes.content}>
              <SubmitButton
                size="medium"
                color="primary"
                variant="secondary"
                onClick={data.onActionClick}>
                {data.actionLabel}
              </SubmitButton>
            </div>
          </ButtonContainer>
          :
          <div className={classes.content}>
            <SubmitButton
              size="medium"
              color="primary"
              variant="secondary"
              onClick={data.onActionClick}>
              {data.actionLabel}
            </SubmitButton>
          </div>
        }
      </section>
    </div>
  ) 
}

ActionButtonToast.propTypes = {
  data: PropTypes.any,
  open: PropTypes.bool,
  classes: PropTypes.object,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(ActionButtonToast)



// WEBPACK FOOTER //
// ./src/components/atoms/toasts/ActionButtonToast.js